module.exports = {"510811001":"拣银岩社区街道","510811100":"元坝镇","510811101":"卫子镇","510811102":"王家镇","510811103":"磨滩镇","510811104":"柏林沟镇","510811105":"太公镇","510811106":"虎跳镇","510811107":"红岩镇","510811108":"昭化镇","510811109":"石井铺镇","510811110":"明觉镇","510811200":"晋贤乡","510811201":"文村乡","510811202":"清水乡","510811203":"张家乡","510811204":"香溪乡","510811205":"青牛乡","510811206":"陈江乡","510811207":"丁家乡","510811208":"黄龙乡","510811210":"白果乡","510811211":"梅树乡","510811213":"射箭乡","510811214":"朝阳乡","510811215":"大朝乡","510811216":"沙坝乡","510811217":"柳桥乡","510811218":"紫云乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/510811.json
// module id = 2311
// module chunks = 0